// AUTO-GENERATED
export const ADW_SCHOOLS = {
  "state": {
    "total_schools": 1138,
    "schools_running": 1120,
    "schools_zero": 18,
    "boys": 34851,
    "girls": 33803,
    "total": 68684
  },
  "districts": {
    "TIRUVALLUR": {
      "total_schools": 56,
      "schools_running": 56,
      "schools_zero": 0,
      "boys": 2078,
      "girls": 2159,
      "total": 4237
    },
    "CHENNAI": {
      "total_schools": 24,
      "schools_running": 21,
      "schools_zero": 3,
      "boys": 1489,
      "girls": 1427,
      "total": 2932
    },
    "KANCHEEPURAM": {
      "total_schools": 30,
      "schools_running": 30,
      "schools_zero": 0,
      "boys": 1223,
      "girls": 1108,
      "total": 2331
    },
    "CHENGALPATTU": {
      "total_schools": 62,
      "schools_running": 58,
      "schools_zero": 4,
      "boys": 3367,
      "girls": 3132,
      "total": 6499
    },
    "RANIPET": {
      "total_schools": 53,
      "schools_running": 53,
      "schools_zero": 0,
      "boys": 1252,
      "girls": 1452,
      "total": 2704
    },
    "VELLORE": {
      "total_schools": 59,
      "schools_running": 59,
      "schools_zero": 0,
      "boys": 1818,
      "girls": 1746,
      "total": 3564
    },
    "TIRUPATHUR": {
      "total_schools": 13,
      "schools_running": 13,
      "schools_zero": 0,
      "boys": 519,
      "girls": 482,
      "total": 1001
    },
    "DHARMAPURI": {
      "total_schools": 10,
      "schools_running": 10,
      "schools_zero": 0,
      "boys": 282,
      "girls": 296,
      "total": 578
    },
    "TIRUVANNAMALAI": {
      "total_schools": 62,
      "schools_running": 60,
      "schools_zero": 2,
      "boys": 1335,
      "girls": 1370,
      "total": 2714
    },
    "VILLUPURAM": {
      "total_schools": 64,
      "schools_running": 63,
      "schools_zero": 1,
      "boys": 1802,
      "girls": 1954,
      "total": 3760
    },
    "KALLAKURICHI": {
      "total_schools": 28,
      "schools_running": 28,
      "schools_zero": 0,
      "boys": 1081,
      "girls": 1092,
      "total": 2173
    },
    "SALEM": {
      "total_schools": 13,
      "schools_running": 13,
      "schools_zero": 0,
      "boys": 602,
      "girls": 488,
      "total": 1090
    },
    "NAMAKKAL": {
      "total_schools": 7,
      "schools_running": 7,
      "schools_zero": 0,
      "boys": 338,
      "girls": 299,
      "total": 637
    },
    "ERODE": {
      "total_schools": 4,
      "schools_running": 4,
      "schools_zero": 0,
      "boys": 60,
      "girls": 59,
      "total": 119
    },
    "THE NILGIRIS": {
      "total_schools": 7,
      "schools_running": 6,
      "schools_zero": 1,
      "boys": 67,
      "girls": 52,
      "total": 119
    },
    "COIMBATORE": {
      "total_schools": 16,
      "schools_running": 15,
      "schools_zero": 1,
      "boys": 383,
      "girls": 446,
      "total": 829
    },
    "TIRUPPUR": {
      "total_schools": 9,
      "schools_running": 8,
      "schools_zero": 1,
      "boys": 312,
      "girls": 336,
      "total": 648
    },
    "DINDIGUL": {
      "total_schools": 13,
      "schools_running": 13,
      "schools_zero": 0,
      "boys": 367,
      "girls": 288,
      "total": 655
    },
    "KARUR": {
      "total_schools": 27,
      "schools_running": 27,
      "schools_zero": 0,
      "boys": 948,
      "girls": 740,
      "total": 1688
    },
    "TIRUCHIRAPPALLI": {
      "total_schools": 102,
      "schools_running": 99,
      "schools_zero": 3,
      "boys": 3049,
      "girls": 3175,
      "total": 6224
    },
    "ARIYALUR": {
      "total_schools": 25,
      "schools_running": 25,
      "schools_zero": 0,
      "boys": 636,
      "girls": 622,
      "total": 1258
    },
    "PERAMBALUR": {
      "total_schools": 33,
      "schools_running": 33,
      "schools_zero": 0,
      "boys": 731,
      "girls": 690,
      "total": 1421
    },
    "CUDDALORE": {
      "total_schools": 126,
      "schools_running": 126,
      "schools_zero": 0,
      "boys": 3797,
      "girls": 3622,
      "total": 7419
    },
    "NAGAPATTINAM": {
      "total_schools": 13,
      "schools_running": 13,
      "schools_zero": 0,
      "boys": 190,
      "girls": 195,
      "total": 385
    },
    "MAYILADUTHURAI": {
      "total_schools": 35,
      "schools_running": 35,
      "schools_zero": 0,
      "boys": 642,
      "girls": 611,
      "total": 1253
    },
    "TIRUVARUR": {
      "total_schools": 31,
      "schools_running": 30,
      "schools_zero": 1,
      "boys": 632,
      "girls": 665,
      "total": 1297
    },
    "THANJAVUR": {
      "total_schools": 100,
      "schools_running": 100,
      "schools_zero": 0,
      "boys": 2038,
      "girls": 1921,
      "total": 3959
    },
    "PUDUKKOTTAI": {
      "total_schools": 13,
      "schools_running": 13,
      "schools_zero": 0,
      "boys": 498,
      "girls": 489,
      "total": 987
    },
    "SIVAGANGAI": {
      "total_schools": 6,
      "schools_running": 6,
      "schools_zero": 0,
      "boys": 230,
      "girls": 210,
      "total": 440
    },
    "MADURAI": {
      "total_schools": 18,
      "schools_running": 18,
      "schools_zero": 0,
      "boys": 766,
      "girls": 640,
      "total": 1406
    },
    "THENI": {
      "total_schools": 9,
      "schools_running": 9,
      "schools_zero": 0,
      "boys": 406,
      "girls": 353,
      "total": 759
    },
    "VIRUDHUNAGAR": {
      "total_schools": 20,
      "schools_running": 20,
      "schools_zero": 0,
      "boys": 527,
      "girls": 448,
      "total": 975
    },
    "RAMANATHAPURAM": {
      "total_schools": 11,
      "schools_running": 11,
      "schools_zero": 0,
      "boys": 301,
      "girls": 262,
      "total": 564
    },
    "THOOTHUKKUDI": {
      "total_schools": 13,
      "schools_running": 13,
      "schools_zero": 0,
      "boys": 233,
      "girls": 201,
      "total": 434
    },
    "TIRUNELVELI": {
      "total_schools": 16,
      "schools_running": 16,
      "schools_zero": 0,
      "boys": 503,
      "girls": 445,
      "total": 948
    },
    "TENKASI": {
      "total_schools": 2,
      "schools_running": 2,
      "schools_zero": 0,
      "boys": 58,
      "girls": 47,
      "total": 105
    },
    "KANNIYAKUMARI": {
      "total_schools": 6,
      "schools_running": 5,
      "schools_zero": 1,
      "boys": 194,
      "girls": 181,
      "total": 375
    },
    "KRISHNAGIRI": {
      "total_schools": 2,
      "schools_running": 2,
      "schools_zero": 0,
      "boys": 97,
      "girls": 100,
      "total": 197
    }
  }
};
export const TW_SCHOOLS = {
  "state": {
    "total_schools": 324,
    "schools_running": 321,
    "schools_zero": 3,
    "boys": 14647,
    "girls": 13303,
    "total": 27950
  },
  "districts": {
    "CHENGALPATTU": {
      "total_schools": 1,
      "schools_running": 1,
      "schools_zero": 0,
      "boys": 184,
      "girls": 132,
      "total": 316
    },
    "COIMBATORE": {
      "total_schools": 16,
      "schools_running": 16,
      "schools_zero": 0,
      "boys": 371,
      "girls": 401,
      "total": 772
    },
    "CUDDALORE": {
      "total_schools": 1,
      "schools_running": 1,
      "schools_zero": 0,
      "boys": 38,
      "girls": 33,
      "total": 71
    },
    "DHARMAPURI": {
      "total_schools": 32,
      "schools_running": 32,
      "schools_zero": 0,
      "boys": 1000,
      "girls": 939,
      "total": 1939
    },
    "DINDIGUL": {
      "total_schools": 7,
      "schools_running": 7,
      "schools_zero": 0,
      "boys": 125,
      "girls": 96,
      "total": 221
    },
    "ERODE": {
      "total_schools": 22,
      "schools_running": 21,
      "schools_zero": 1,
      "boys": 862,
      "girls": 730,
      "total": 1592
    },
    "KALLAKURICHI": {
      "total_schools": 48,
      "schools_running": 48,
      "schools_zero": 0,
      "boys": 3205,
      "girls": 2985,
      "total": 6190
    },
    "KANNIYAKUMARI": {
      "total_schools": 7,
      "schools_running": 7,
      "schools_zero": 0,
      "boys": 330,
      "girls": 366,
      "total": 696
    },
    "NAMAKKAL": {
      "total_schools": 9,
      "schools_running": 9,
      "schools_zero": 0,
      "boys": 1205,
      "girls": 1001,
      "total": 2206
    },
    "PERAMBALUR": {
      "total_schools": 2,
      "schools_running": 2,
      "schools_zero": 0,
      "boys": 40,
      "girls": 22,
      "total": 62
    },
    "SALEM": {
      "total_schools": 63,
      "schools_running": 62,
      "schools_zero": 1,
      "boys": 2952,
      "girls": 2890,
      "total": 5842
    },
    "THE NILGIRIS": {
      "total_schools": 30,
      "schools_running": 30,
      "schools_zero": 0,
      "boys": 1227,
      "girls": 1126,
      "total": 2353
    },
    "THENI": {
      "total_schools": 2,
      "schools_running": 2,
      "schools_zero": 0,
      "boys": 8,
      "girls": 11,
      "total": 19
    },
    "THENKASI": {
      "total_schools": 1,
      "schools_running": 1,
      "schools_zero": 0,
      "boys": 4,
      "girls": 5,
      "total": 9
    },
    "TIRUCHIRAPPALLI": {
      "total_schools": 28,
      "schools_running": 27,
      "schools_zero": 1,
      "boys": 521,
      "girls": 478,
      "total": 999
    },
    "TIRUNELVELI": {
      "total_schools": 2,
      "schools_running": 2,
      "schools_zero": 0,
      "boys": 59,
      "girls": 39,
      "total": 98
    },
    "TIRUPATHUR": {
      "total_schools": 8,
      "schools_running": 8,
      "schools_zero": 0,
      "boys": 474,
      "girls": 393,
      "total": 867
    },
    "TIRUPPUR": {
      "total_schools": 5,
      "schools_running": 5,
      "schools_zero": 0,
      "boys": 83,
      "girls": 59,
      "total": 142
    },
    "TIRUVANNAMALAI": {
      "total_schools": 33,
      "schools_running": 33,
      "schools_zero": 0,
      "boys": 1836,
      "girls": 1469,
      "total": 3305
    },
    "VELLORE": {
      "total_schools": 6,
      "schools_running": 6,
      "schools_zero": 0,
      "boys": 103,
      "girls": 110,
      "total": 213
    },
    "VILLUPURAM": {
      "total_schools": 1,
      "schools_running": 1,
      "schools_zero": 0,
      "boys": 20,
      "girls": 18,
      "total": 38
    }
  }
};
